module.exports = __webpack_public_path__ + "img/cpbox-online.13714d13.png";